import * as React from "react"
import { Link } from "gatsby"

const Pagination = ({ numPages, currentPage, pageLimit, pagingPath, hasRootUrl }) => {
  const getPaginationGroup = () => {
    let start = Math.floor((currentPage - 1) / pageLimit) * pageLimit
    const pages =
      numPages < pageLimit
        ? numPages
        : numPages >= start + pageLimit
        ? pageLimit
        : numPages - start

    return new Array(pages).fill().map((_, idx) => start + idx + 1)
  }

  return (
    <div className="flex justify-center items-center flex-gap-2">
      {currentPage === 1 ? (
        <span className="p-4">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.293 6.29303L7.586 12L13.293 17.707L14.707 16.293L10.414 12L14.707 7.70703L13.293 6.29303Z"
              fill="#C4C4C4"
            />
          </svg>
        </span>
      ) : (
        <Link
          to={
            hasRootUrl && currentPage === 2
              ? pagingPath
              : `${pagingPath}${currentPage - 1}/`
          }
          className={`p-4 hover:opacity-70`}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.293 6.29303L7.586 12L13.293 17.707L14.707 16.293L10.414 12L14.707 7.70703L13.293 6.29303Z"
              fill="#031E43"
            />
          </svg>
        </Link>
      )}

      {/* show page numbers */}
      {getPaginationGroup().map((item, index) => (
        <Link
          key={index}
          to={hasRootUrl && item === 1 ? pagingPath : `${pagingPath}${item}/`}
          className={`text-white w-10 h-10 rounded-full flex justify-center items-center  ${
            currentPage === item
              ? " bg-textGray-60"
              : "bg-brandNavy hover:opacity-80"
          }`}
        >
          <span>{item}</span>
        </Link>
      ))}

      {/* next button */}
      {currentPage === numPages ? (
        <span className="p-4">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.707 17.707L16.414 12L10.707 6.29297L9.293 7.70697L13.586 12L9.293 16.293L10.707 17.707Z"
              fill="#C4C4C4"
            />
          </svg>
        </span>
      ) : (
        <Link
          to={`${pagingPath}${currentPage + 1}/`}
          className={`p-4 hover:opacity-70`}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.707 17.707L16.414 12L10.707 6.29297L9.293 7.70697L13.586 12L9.293 16.293L10.707 17.707Z"
              fill="#031E43"
            />
          </svg>
        </Link>
      )}
    </div>
  )
}

export default Pagination
